import styled from "@emotion/styled";
import React, { MouseEvent, ReactNode } from "react";

import useAnalytics from "@brexhq/next/src/hooks/useAnalytics";
import { ButtonClickedEvent } from "@brexhq/next/src/telemetry/analyticsEvents";

export const UnstyledRebirthButton = styled.button({
  padding: 0,
  border: "none",
  background: "none",
  "&:focus": {
    outline: "none",
  },
  textAlign: "unset",
  width: "100%",
});

interface Props {
  className?: string;
  children?: ReactNode;
  component: string;
  label: ReactNode;
  section?: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  testId?: string;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  id?: string;
}

/**
 * @deprecated avoid using, pending Button refactor
 */
export const UnstyledButton = ({
  className,
  component,
  label,
  section = "",
  onClick,
  testId = "rebirth-button-unstyled",
  type = "button",
  id,
  children,
}: Props) => {
  const { trackEvent } = useAnalytics();

  const buttonClicked = (e: MouseEvent<HTMLButtonElement>) => {
    onClick(e);

    trackEvent(
      new ButtonClickedEvent(
        component,
        section,
        "unstyled",
        typeof label === "string" ? label : "",
      ),
    );
  };

  return (
    <UnstyledRebirthButton
      className={className}
      onClick={buttonClicked}
      data-testid={testId}
      id={id}
      type={type}
    >
      {children}
    </UnstyledRebirthButton>
  );
};
